import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import { DashboardFormData, DashboardFormDataFactoryFromJS } from './DashboardFormData';

export interface IBaseStartupState {
	panelId?: string;
	childModuleGuid?: string;
	childModuleIsActive?: boolean;
}

export interface IStartupState extends IBaseStartupState {
	dashboardFormData?: DashboardFormData;
}
export interface IReadonlyStartupState extends IBaseStartupState {
	dashboardFormData?: DashboardFormData;
}

export type StartupState = ReadonlyRecord<IReadonlyStartupState>;

export const StartupStateFactory = Record<IReadonlyStartupState>({
	panelId: '',
	childModuleGuid: '',
	childModuleIsActive: false,
	dashboardFormData: null
});

export const StartupStateFactoryFromJS = function (data: IStartupState) {
	return StartupStateFactory({
		...data,
		dashboardFormData: data.dashboardFormData
			? DashboardFormDataFactoryFromJS(data.dashboardFormData)
			: null
	});
};
